// extracted by mini-css-extract-plugin
export default {"tab":"UserPasses_tab__0kjvP"};